<template>
  <v-data-table
    :headers="columnas"
    :items="itemsDB"
    :loading="loading"
    loading-text="Cargando..."
    :hide-default-footer="true"
    dense
  >
    <!-- <template v-slot:header.Nombre="{ header }">
      {{ header.text.toUpperCase() }}
    </template> -->
    <template v-slot:item="{ item }">
      <tr>
        <td v-for="columna in columnas" :key="columna.value">
          <template v-if="columna.mask == undefined">{{
            item[columna.value]
          }}</template>
          <template v-else>
            <template v-if="columna.mask == 'esFecha'">{{
              item[columna.value] | esFecha
            }}</template>
            <template v-else>
              <template v-if="columna.mask == 'esMoneda'">
                {{ item[columna.value] | esMoneda }}
              </template>
            </template>
          </template>
        </td>
        <td width="100">
          <v-layout row wrap right>
            <v-flex xs6 md6>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    icon
                    small
                    color="primary"
                    v-if="!sinAccionEditar"
                    @click="editarItem(item)"
                    v-on="on"
                  >
                    <v-icon>edit</v-icon>
                  </v-btn>
                </template>
                <span>Editar</span>
              </v-tooltip>
            </v-flex>
            <v-flex xs6 md6>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    icon
                    small
                    color="error"
                    v-if="!sinAccionBorrar"
                    @click="borrarItem(item)"
                    v-on="on"
                  >
                    <v-icon>delete_outline</v-icon>
                  </v-btn>
                </template>
                <span>Borrar</span>
              </v-tooltip>
            </v-flex>
          </v-layout>
        </td>
      </tr>
    </template>
    <template v-slot:no-data
      >-</template
    >
  </v-data-table>
</template>

<script>
export default {
  name: "Grilla",
  props: {
    columnas: {},
    itemsDB: {},
    loading: Boolean,
    sinAccionEditar: Boolean,
    sinAccionBorrar: Boolean
  },
  data() {
    return {};
  },
  methods: {
    editarItem(item) {
      this.$emit("editarItem", item);
    },
    borrarItem(item) {
      this.$emit("borrarItem", item);
    }
  }
};
</script>
